import React from "react";

export default function Footer() {
	return (
		<React.Fragment>
			<footer className="bg-primary py-10">
				<div className="container mx-auto">
					<p className="text-white text-center">
						Copyright &copy; Ecommerce Shop 2023. All rights reserved
					</p>
				</div>
			</footer>
		</React.Fragment>
	);
}
